import { render, staticRenderFns } from "./LayoutCenteredTopBar.vue?vue&type=template&id=2b8b7fc5&scoped=true&"
import script from "./LayoutCenteredTopBar.vue?vue&type=script&lang=js&"
export * from "./LayoutCenteredTopBar.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCenteredTopBar.vue?vue&type=style&index=0&id=2b8b7fc5&lang=scss&scoped=true&"
import style1 from "./LayoutCenteredTopBar.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8b7fc5",
  null
  
)

export default component.exports